module.exports = __webpack_public_path__ + "img/info-5.90499e2f.svg";